import { useCallback } from 'react';
import DateTimePickerComponent from '../../DateTimePicker/DateTimePickerComponent';
import { DATE_TIME_TYPE } from '../../DateTimePicker/constants';
import { getCurrentDate, handleOptionChange } from '../utils';
import { getTodayDate } from '@cp/src/pages/CaseDetails/constants/communicationHistory.constant';
import { IDateTimePickerFilterProps } from '../types';
import styles from '../index.module.scss';
import { FiltersWithSubfiltersMapping } from '../constants';

const DateTimePickerFilter = (props: IDateTimePickerFilterProps) => {
  const { filterKey, filterSchema, selectedOptions, setSelectedOptions } = props;

  const defaultDate = getCurrentDate();
  let date: string[] = selectedOptions?.[filterKey];
  if (!date.length) date = defaultDate;

  const handleDateChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      handleOptionChange(
        e,
        { label: FiltersWithSubfiltersMapping.PROMISE_TO_PAY, value: e.target.value },
        filterKey,
        selectedOptions,
        filterSchema,
        setSelectedOptions
      );
    },
    [filterKey, filterSchema, selectedOptions, setSelectedOptions]
  );

  return (
    <DateTimePickerComponent
      type={DATE_TIME_TYPE.DATE}
      value={date}
      onChange={handleDateChange}
      className={styles.datePicker}
    />
  );
};

export default DateTimePickerFilter;
